import { render, staticRenderFns } from "./SendReservationEmailModal.vue?vue&type=template&id=42aa0c06"
import script from "./SendReservationEmailModal.vue?vue&type=script&lang=js"
export * from "./SendReservationEmailModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports